export const loadModelDataWithWorker = () => {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('../workers/modelWorker.ts', import.meta.url), {
            type: 'module',
        });
        worker.onmessage = (e) => {
            const { success, data, error } = e.data;
            worker.terminate();
            if (success) {
                resolve(data);
            }
            else {
                reject(new Error(error));
            }
        };
        worker.onerror = (e) => {
            worker.terminate();
            reject(new Error(e.message));
        };
        worker.postMessage(null);
    });
};
